import type { ApolloClient } from "@apollo/client";

let graphQLClientInstance: ApolloClient<unknown> | null = null;

export function getGraphQLClientInstance() {
  return graphQLClientInstance as ApolloClient<unknown>;
}

export function setGraphQLClientInstance(client: ApolloClient<unknown>) {
  graphQLClientInstance = client;
}
